define(["dojo-proxy-loader?name=dojo/_base/declare!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dijit/_WidgetBase", "dijit/_TemplatedMixin", "dijit/_FocusMixin", "dojo-proxy-loader?name=dojo/_base/array!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/query!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/io-query!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/on!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/_base/lang!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/request/script", "dojo-proxy-loader?name=dojo/dom-form!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-geometry!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-construct!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-style!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-attr!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo-proxy-loader?name=dojo/dom-class!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "dojo/html", "dojo-proxy-loader?name=dojo/Evented!/home/mcdeploy/mc_node_modules_cache/c498397e31349a8eda9bac015e0a41b85d051368/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "mojo/widgets/badges/TextBadge", "dojo/text!./templates/form.html", "dojo/text!./templates/gdprBlock.html", "dojo/text!./inputs/templates/Text.html", "dojo/text!./inputs/templates/Popup/Address.html", "dojo/text!./inputs/templates/Email.html", "dojo/text!./inputs/templates/Birthday.html", "dojo/text!./inputs/templates/Date.html", "dojo/text!./inputs/templates/Phone.html", "dojo/text!./inputs/templates/SmsPhone.html", "dojo/text!./inputs/templates/Number.html", "dojo/text!./inputs/templates/Url.html", "dojo/text!./inputs/templates/Popup/RadioCheckbox.html", "dojo/text!./inputs/templates/GdprCheckbox.html", "dojo/text!./inputs/templates/Select.html"], function (declare, _WidgetBase, _TemplatedMixin, _FocusMixin, array, query, ioQuery, on, lang, script, domForm, domGeom, domConstruct, domStyle, domAttr, domClass, html, Evented, TextBadge, tplForm, tplGdprBlock, tplTextField, tplAddressField, tplEmailField, tplBirthdayField, tplDateField, tplPhoneField, tplSmsPhoneField, tplNumberField, tplUrlField, tplRadioCheckboxField, tplGdprCheckboxField, tplSelectField) {
  var _ValidationTypes = declare([], {
    /* Field (one or more inputs) Validation Methods */
    isEmpty: function () {
      var valid;
      array.forEach(this.inputs, lang.hitch(this, function (input) {
        if (input.type === "radio" || input.type === "checkbox" || input.tagName.toLowerCase() === "option") {
          valid = typeof valid === "boolean" ? valid && !this._checked(input) : !this._checked(input);
        } else {
          valid = typeof valid === "boolean" ? valid && this._empty(input.value) : this._empty(input.value);
        }
      }));
      return valid;
    },
    // At least one option is selected. Use array.some so we can return true as soon as we find a checked input.
    isChecked: function () {
      var checked;
      checked = array.some(this.inputs, lang.hitch(this, function (input) {
        if (this._checked(input)) {
          return true;
        }
      }));
      if (checked) {
        return true;
      }
      return false;
    },
    // An email field contains one input
    isEmail: function () {
      return this._email(this.inputs[0].value);
    },
    // A phone field contains three inputs: area, detail1 and detail2
    isPhone: function () {
      return this._phone(this.phoneAreaNode.value, this.phoneDetail1Node.value, this.phoneDetail2Node.value);
    },
    isUrl: function () {
      return this._url(this.inputs[0].value);
    },
    isNumber: function () {
      return this._number(this.inputs[0].value);
    },
    isBirthday: function () {
      return this._monthDigits(this.monthNode.value) && this._dayDigits(this.dayNode.value);
    },
    isDate: function () {
      return this._yearDigits(this.yearNode.value) && this._monthDigits(this.monthNode.value) && this._dayDigits(this.dayNode.value);
    },
    isAddress: function () {
      return !this._empty(this.address1Node.value) && !this._empty(this.cityNode.value) && !this._empty(this.stateNode.value) && this._checked(query(":checked", this.countrySelectNode)[0]) && !this._empty(this.zipNode.value);
    },
    /* Single Input Validation Methods */
    _required: function (value) {
      return value.trim().length > 0;
    },
    _empty: function (value) {
      return value === null || typeof value === "undefined" || value === "";
    },
    _email: function (value) {
      return /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(value);
    },
    // YYYY [all the digits, i.e. 2012]
    _yearDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 9999]);
    },
    // MM [01 (January) to 12 (December)]
    _monthDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 12]);
    },
    // DD [01 to 31]
    _dayDigits: function (value) {
      return this._digits(value) && this._range(value, [1, 31]);
    },
    _digits: function (value) {
      return /^\d+$/.test(value);
    },
    _range: function (value, param) {
      return value >= param[0] && value <= param[1];
    },
    _number: function (value) {
      return this._digits(value) && !isNaN(value);
    },
    _minlength: function (value, param) {
      return value.trim().length >= param;
    },
    _maxlength: function (value, param) {
      return value.trim().length <= param;
    },
    _exactLength: function (value, param) {
      return value.trim().length === param;
    },
    // US zip code
    _zipcode: function (value) {
      return /^\d{5}-\d{4}$|^\d{5}$/.test(value);
    },
    _url: function (value) {
      return /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
    },
    /* Custom Validation Methods */
    _phone: function (area, detail1, detail2) {
      return this._digits(area) && this._digits(detail1) && this._digits(detail2) && this._exactLength(area, 3) && this._exactLength(detail1, 3) && this._exactLength(detail2, 4);
    },
    _checked: function (node) {
      return node.checked || node.selected && !this._empty(node.value);
    },
    /* Utility Methods */
    _checkable: function (node) {
      return /radio|checkbox/i.test(node.type);
    }
  });
  var _ValidationMixin = declare([_FocusMixin, _ValidationTypes], {
    // TODO: Allow users to supply custom validation messages?

    _onBlur: function () {
      this.inherited(arguments);
      this.validateField();
    },
    validateField: function (translations) {
      var errors = [];
      var valid, message;
      if (this.required) {
        valid = !this.isEmpty(); // TODO: What about the address field which has inputs (e.g., address2) that can be empty?
        if (!valid) {
          errors.push(translations["9303c9bd4f8178680dc382adbfcd62af"]);
        }
      }
      switch (this.validateAsType) {
        case "email":
          valid = this.isEmpty() || this.isEmail();
          message = translations["b5bccda6d3a04e1d8f79846355290435"]; // "Please enter a valid email address."
          break;
        case "address":
          valid = this.isEmpty() || this.isAddress();
          message = translations["65072e37cef3c8e8fe8873937664c67c"]; // "Please enter a valid address."
          break;
        case "phone":
          valid = this.isEmpty() || this.isPhone();
          message = translations["7724076d0ccc93dbb00326dbedfeee14"]; // "Please enter a valid phone number."
          break;
        case "smsphone":
          valid = true;
          message = "Please enter a valid phone number.";
          break;
        case "url":
          valid = this.isEmpty() || this.isUrl(); // TODO: image url validation?
          message = translations["2918dd459b068924e2b6d6df3faa2a47"]; // "Please enter a valid url."
          break;
        case "number":
          valid = this.isEmpty() || this.isNumber();
          message = translations["aae0933b5535a899ca6a790ef963de38"]; // "Please enter a valid number."
          break;
        case "birthday":
          valid = this.isEmpty() || this.isBirthday();
          message = translations["08e0d7dddecd2fbebae22aa3f9d5241d"]; // "Please enter a valid birthday."
          break;
        case "date":
          valid = this.isEmpty() || this.isDate();
          message = translations["773fcd7a2070fcf96c72ea6540c77eb8"]; // "Please enter a valid date."
          break;
        case "radiocheckbox":
        case "select":
          valid = this.isEmpty() || this.isChecked();
          break;
        default:
          valid = true;
        // NOTE: generic text inputs are valid by default
      }
      if (!valid) {
        errors.push(message);
      }
      this.setFieldValidationStatus(errors);
      return errors;
    },
    setFieldValidationStatus: function (errors) {
      if (errors.length > 0) {
        this.setFieldAsInvalid(errors[0]);
      } else {
        this.setFieldAsValid();
      }
    },
    setFieldAsInvalid: function (message) {
      this.inputs.addClass("invalid").removeClass("valid");
      html.set(this.errorsNode, message);
      domStyle.set(this.errorsNode, "display", "block");
      if (this.placeholderNode) {
        domStyle.set(this.placeholderNode, "display", "none");
      }
    },
    setFieldAsValid: function () {
      this.inputs.addClass("valid").removeClass("invalid");
      domStyle.set(this.errorsNode, "display", "none");
      if (this.placeholderNode) {
        domStyle.set(this.placeholderNode, "display", "block");
      }
    },
    resetField: function () {
      this.inputs.removeClass("valid").removeClass("invalid");
      domStyle.set(this.errorsNode, "display", "none");
      if (this.placeholderNode) {
        domStyle.set(this.placeholderNode, "display", "block");
      }
    },
    _getErrorsNode: function () {
      var node = query(".invalid-error", this.domNode)[0];
      if (!node) {
        node = domConstruct.place('<div class="invalid-error"></div>', this.domNode);
      }
      return node;
    }
  });
  var _BaseField = declare([_WidgetBase, _TemplatedMixin, _ValidationMixin], {
    required: false,
    inputs: [],
    errorsNode: null,
    placeholderNode: null,
    postCreate: function () {
      this.inputs = query("input:not([type='hidden']), select option", this.domNode);
      this.setupPlaceHelperText();
      this.errorsNode = this._getErrorsNode();
    },
    setupPlaceHelperText: function () {
      if (!this.helper_text) {
        // Delete any placeholder from the template as the field doesn't need it
        if (this.placeholderNode) {
          domConstruct.destroy(this.placeholderNode);
        }
        return;
      }
      var entry = this.placeholderNode ? this.placeholderNode : this._createPlaceholderNode();
      entry.innerText = this.helper_text;
      this.placeholderNode = entry;
    },
    // Creates a node at the bottom of the field for placeholder. Used when there's no predefined node.
    _createPlaceholderNode: function () {
      return domConstruct.place('<div class="helpText"></div>', this.domNode);
    }
  });
  var TextField = declare([_BaseField], {
    templateString: tplTextField,
    validateAsType: "text"
  });
  var NumberField = declare([_BaseField], {
    templateString: tplNumberField,
    validateAsType: "number"
  });
  var AddressField = declare([_BaseField], {
    templateString: tplAddressField,
    validateAsType: "address",
    postCreate: function () {
      var countries = [{
        "id": "286",
        "name": "Aaland Islands"
      }, {
        "id": "274",
        "name": "Afghanistan"
      }, {
        "id": "2",
        "name": "Albania"
      }, {
        "id": "3",
        "name": "Algeria"
      }, {
        "id": "178",
        "name": "American Samoa"
      }, {
        "id": "4",
        "name": "Andorra"
      }, {
        "id": "5",
        "name": "Angola"
      }, {
        "id": "176",
        "name": "Anguilla"
      }, {
        "id": "175",
        "name": "Antigua And Barbuda"
      }, {
        "id": "6",
        "name": "Argentina"
      }, {
        "id": "7",
        "name": "Armenia"
      }, {
        "id": "179",
        "name": "Aruba"
      }, {
        "id": "8",
        "name": "Australia"
      }, {
        "id": "9",
        "name": "Austria"
      }, {
        "id": "10",
        "name": "Azerbaijan"
      }, {
        "id": "11",
        "name": "Bahamas"
      }, {
        "id": "12",
        "name": "Bahrain"
      }, {
        "id": "13",
        "name": "Bangladesh"
      }, {
        "id": "14",
        "name": "Barbados"
      }, {
        "id": "15",
        "name": "Belarus"
      }, {
        "id": "16",
        "name": "Belgium"
      }, {
        "id": "17",
        "name": "Belize"
      }, {
        "id": "18",
        "name": "Benin"
      }, {
        "id": "19",
        "name": "Bermuda"
      }, {
        "id": "20",
        "name": "Bhutan"
      }, {
        "id": "21",
        "name": "Bolivia"
      }, {
        "id": "22",
        "name": "Bosnia and Herzegovina"
      }, {
        "id": "23",
        "name": "Botswana"
      }, {
        "id": "181",
        "name": "Bouvet Island"
      }, {
        "id": "24",
        "name": "Brazil"
      }, {
        "id": "180",
        "name": "Brunei Darussalam"
      }, {
        "id": "25",
        "name": "Bulgaria"
      }, {
        "id": "26",
        "name": "Burkina Faso"
      }, {
        "id": "27",
        "name": "Burundi"
      }, {
        "id": "28",
        "name": "Cambodia"
      }, {
        "id": "29",
        "name": "Cameroon"
      }, {
        "id": "30",
        "name": "Canada"
      }, {
        "id": "31",
        "name": "Cape Verde"
      }, {
        "id": "32",
        "name": "Cayman Islands"
      }, {
        "id": "33",
        "name": "Central African Republic"
      }, {
        "id": "34",
        "name": "Chad"
      }, {
        "id": "35",
        "name": "Chile"
      }, {
        "id": "36",
        "name": "China"
      }, {
        "id": "185",
        "name": "Christmas Island"
      }, {
        "id": "37",
        "name": "Colombia"
      }, {
        "id": "204",
        "name": "Comoros"
      }, {
        "id": "38",
        "name": "Congo"
      }, {
        "id": "183",
        "name": "Cook Islands"
      }, {
        "id": "268",
        "name": "Costa Rica"
      }, {
        "id": "275",
        "name": "Cote D'Ivoire"
      }, {
        "id": "40",
        "name": "Croatia"
      }, {
        "id": "276",
        "name": "Cuba"
      }, {
        "id": "298",
        "name": "Curacao"
      }, {
        "id": "41",
        "name": "Cyprus"
      }, {
        "id": "42",
        "name": "Czech Republic"
      }, {
        "id": "43",
        "name": "Denmark"
      }, {
        "id": "44",
        "name": "Djibouti"
      }, {
        "id": "289",
        "name": "Dominica"
      }, {
        "id": "187",
        "name": "Dominican Republic"
      }, {
        "id": "233",
        "name": "East Timor"
      }, {
        "id": "45",
        "name": "Ecuador"
      }, {
        "id": "46",
        "name": "Egypt"
      }, {
        "id": "47",
        "name": "El Salvador"
      }, {
        "id": "48",
        "name": "Equatorial Guinea"
      }, {
        "id": "49",
        "name": "Eritrea"
      }, {
        "id": "50",
        "name": "Estonia"
      }, {
        "id": "51",
        "name": "Ethiopia"
      }, {
        "id": "189",
        "name": "Falkland Islands"
      }, {
        "id": "191",
        "name": "Faroe Islands"
      }, {
        "id": "52",
        "name": "Fiji"
      }, {
        "id": "53",
        "name": "Finland"
      }, {
        "id": "54",
        "name": "France"
      }, {
        "id": "193",
        "name": "French Guiana"
      }, {
        "id": "277",
        "name": "French Polynesia"
      }, {
        "id": "56",
        "name": "Gabon"
      }, {
        "id": "57",
        "name": "Gambia"
      }, {
        "id": "58",
        "name": "Georgia"
      }, {
        "id": "59",
        "name": "Germany"
      }, {
        "id": "60",
        "name": "Ghana"
      }, {
        "id": "194",
        "name": "Gibraltar"
      }, {
        "id": "61",
        "name": "Greece"
      }, {
        "id": "195",
        "name": "Greenland"
      }, {
        "id": "192",
        "name": "Grenada"
      }, {
        "id": "196",
        "name": "Guadeloupe"
      }, {
        "id": "62",
        "name": "Guam"
      }, {
        "id": "198",
        "name": "Guatemala"
      }, {
        "id": "270",
        "name": "Guernsey"
      }, {
        "id": "63",
        "name": "Guinea"
      }, {
        "id": "65",
        "name": "Guyana"
      }, {
        "id": "200",
        "name": "Haiti"
      }, {
        "id": "66",
        "name": "Honduras"
      }, {
        "id": "67",
        "name": "Hong Kong"
      }, {
        "id": "68",
        "name": "Hungary"
      }, {
        "id": "69",
        "name": "Iceland"
      }, {
        "id": "70",
        "name": "India"
      }, {
        "id": "71",
        "name": "Indonesia"
      }, {
        "id": "278",
        "name": "Iran"
      }, {
        "id": "279",
        "name": "Iraq"
      }, {
        "id": "74",
        "name": "Ireland"
      }, {
        "id": "75",
        "name": "Israel"
      }, {
        "id": "76",
        "name": "Italy"
      }, {
        "id": "202",
        "name": "Jamaica"
      }, {
        "id": "78",
        "name": "Japan"
      }, {
        "id": "288",
        "name": "Jersey  (Channel Islands)"
      }, {
        "id": "79",
        "name": "Jordan"
      }, {
        "id": "80",
        "name": "Kazakhstan"
      }, {
        "id": "81",
        "name": "Kenya"
      }, {
        "id": "203",
        "name": "Kiribati"
      }, {
        "id": "82",
        "name": "Kuwait"
      }, {
        "id": "83",
        "name": "Kyrgyzstan"
      }, {
        "id": "84",
        "name": "Lao People's Democratic Republic"
      }, {
        "id": "85",
        "name": "Latvia"
      }, {
        "id": "86",
        "name": "Lebanon"
      }, {
        "id": "87",
        "name": "Lesotho"
      }, {
        "id": "88",
        "name": "Liberia"
      }, {
        "id": "281",
        "name": "Libya"
      }, {
        "id": "90",
        "name": "Liechtenstein"
      }, {
        "id": "91",
        "name": "Lithuania"
      }, {
        "id": "92",
        "name": "Luxembourg"
      }, {
        "id": "208",
        "name": "Macau"
      }, {
        "id": "93",
        "name": "Macedonia"
      }, {
        "id": "94",
        "name": "Madagascar"
      }, {
        "id": "95",
        "name": "Malawi"
      }, {
        "id": "96",
        "name": "Malaysia"
      }, {
        "id": "97",
        "name": "Maldives"
      }, {
        "id": "98",
        "name": "Mali"
      }, {
        "id": "99",
        "name": "Malta"
      }, {
        "id": "207",
        "name": "Marshall Islands"
      }, {
        "id": "210",
        "name": "Martinique"
      }, {
        "id": "100",
        "name": "Mauritania"
      }, {
        "id": "212",
        "name": "Mauritius"
      }, {
        "id": "241",
        "name": "Mayotte"
      }, {
        "id": "101",
        "name": "Mexico"
      }, {
        "id": "102",
        "name": "Moldova, Republic of"
      }, {
        "id": "103",
        "name": "Monaco"
      }, {
        "id": "104",
        "name": "Mongolia"
      }, {
        "id": "290",
        "name": "Montenegro"
      }, {
        "id": "294",
        "name": "Montserrat"
      }, {
        "id": "105",
        "name": "Morocco"
      }, {
        "id": "106",
        "name": "Mozambique"
      }, {
        "id": "242",
        "name": "Myanmar"
      }, {
        "id": "107",
        "name": "Namibia"
      }, {
        "id": "108",
        "name": "Nepal"
      }, {
        "id": "109",
        "name": "Netherlands"
      }, {
        "id": "110",
        "name": "Netherlands Antilles"
      }, {
        "id": "213",
        "name": "New Caledonia"
      }, {
        "id": "111",
        "name": "New Zealand"
      }, {
        "id": "112",
        "name": "Nicaragua"
      }, {
        "id": "113",
        "name": "Niger"
      }, {
        "id": "114",
        "name": "Nigeria"
      }, {
        "id": "217",
        "name": "Niue"
      }, {
        "id": "214",
        "name": "Norfolk Island"
      }, {
        "id": "272",
        "name": "North Korea"
      }, {
        "id": "116",
        "name": "Norway"
      }, {
        "id": "117",
        "name": "Oman"
      }, {
        "id": "118",
        "name": "Pakistan"
      }, {
        "id": "222",
        "name": "Palau"
      }, {
        "id": "282",
        "name": "Palestine"
      }, {
        "id": "119",
        "name": "Panama"
      }, {
        "id": "219",
        "name": "Papua New Guinea"
      }, {
        "id": "120",
        "name": "Paraguay"
      }, {
        "id": "121",
        "name": "Peru"
      }, {
        "id": "122",
        "name": "Philippines"
      }, {
        "id": "221",
        "name": "Pitcairn"
      }, {
        "id": "123",
        "name": "Poland"
      }, {
        "id": "124",
        "name": "Portugal"
      }, {
        "id": "126",
        "name": "Qatar"
      }, {
        "id": "315",
        "name": "Republic of Kosovo"
      }, {
        "id": "127",
        "name": "Reunion"
      }, {
        "id": "128",
        "name": "Romania"
      }, {
        "id": "129",
        "name": "Russia"
      }, {
        "id": "130",
        "name": "Rwanda"
      }, {
        "id": "205",
        "name": "Saint Kitts and Nevis"
      }, {
        "id": "206",
        "name": "Saint Lucia"
      }, {
        "id": "237",
        "name": "Saint Vincent and the Grenadines"
      }, {
        "id": "132",
        "name": "Samoa (Independent)"
      }, {
        "id": "227",
        "name": "San Marino"
      }, {
        "id": "133",
        "name": "Saudi Arabia"
      }, {
        "id": "134",
        "name": "Senegal"
      }, {
        "id": "266",
        "name": "Serbia"
      }, {
        "id": "135",
        "name": "Seychelles"
      }, {
        "id": "136",
        "name": "Sierra Leone"
      }, {
        "id": "137",
        "name": "Singapore"
      }, {
        "id": "302",
        "name": "Sint Maarten"
      }, {
        "id": "138",
        "name": "Slovakia"
      }, {
        "id": "139",
        "name": "Slovenia"
      }, {
        "id": "223",
        "name": "Solomon Islands"
      }, {
        "id": "140",
        "name": "Somalia"
      }, {
        "id": "141",
        "name": "South Africa"
      }, {
        "id": "257",
        "name": "South Georgia and the South Sandwich Islands"
      }, {
        "id": "142",
        "name": "South Korea"
      }, {
        "id": "311",
        "name": "South Sudan"
      }, {
        "id": "143",
        "name": "Spain"
      }, {
        "id": "144",
        "name": "Sri Lanka"
      }, {
        "id": "293",
        "name": "Sudan"
      }, {
        "id": "146",
        "name": "Suriname"
      }, {
        "id": "225",
        "name": "Svalbard and Jan Mayen Islands"
      }, {
        "id": "147",
        "name": "Swaziland"
      }, {
        "id": "148",
        "name": "Sweden"
      }, {
        "id": "149",
        "name": "Switzerland"
      }, {
        "id": "285",
        "name": "Syria"
      }, {
        "id": "152",
        "name": "Taiwan"
      }, {
        "id": "260",
        "name": "Tajikistan"
      }, {
        "id": "153",
        "name": "Tanzania"
      }, {
        "id": "154",
        "name": "Thailand"
      }, {
        "id": "155",
        "name": "Togo"
      }, {
        "id": "232",
        "name": "Tonga"
      }, {
        "id": "234",
        "name": "Trinidad and Tobago"
      }, {
        "id": "156",
        "name": "Tunisia"
      }, {
        "id": "157",
        "name": "Turkey"
      }, {
        "id": "287",
        "name": "Turks &amp; Caicos Islands"
      }, {
        "id": "159",
        "name": "Uganda"
      }, {
        "id": "161",
        "name": "Ukraine"
      }, {
        "id": "162",
        "name": "United Arab Emirates"
      }, {
        "id": "262",
        "name": "United Kingdom"
      }, {
        "id": "163",
        "name": "Uruguay"
      }, {
        "id": "165",
        "name": "Uzbekistan"
      }, {
        "id": "239",
        "name": "Vanuatu"
      }, {
        "id": "166",
        "name": "Vatican City State (Holy See)"
      }, {
        "id": "167",
        "name": "Venezuela"
      }, {
        "id": "168",
        "name": "Vietnam"
      }, {
        "id": "169",
        "name": "Virgin Islands (British)"
      }, {
        "id": "238",
        "name": "Virgin Islands (U.S.)"
      }, {
        "id": "188",
        "name": "Western Sahara"
      }, {
        "id": "170",
        "name": "Yemen"
      }, {
        "id": "173",
        "name": "Zambia"
      }, {
        "id": "174",
        "name": "Zimbabwe"
      }];
      array.forEach(countries, lang.hitch(this, function (country) {
        var el = '<option value="' + country.id + '">' + country.name + "</option>";
        domConstruct.place(el, this.countrySelectNode, "last");
      }));
      this.inherited(arguments);
    }
  });
  var EmailField = declare([_BaseField], {
    templateString: tplEmailField,
    validateAsType: "email",
    // Toggle placeholder text on email field.
    toggleEmailPlaceholder: function (toggle) {
      if (toggle) {
        domAttr.set(this.emailInput, "placeholder", "Enter your email");
      } else {
        domAttr.remove(this.emailInput, "placeholder");
      }
    }
  });
  var BirthdayField = declare([_BaseField], {
    templateString: tplBirthdayField,
    validateAsType: "birthday",
    validateAsGroup: true,
    postCreate: function () {
      this.inherited(arguments);
      if (this.dateformat === "DD/MM") {
        domConstruct.place(this.dayNode, this.inputsContainer, "first");
        domConstruct.place(this.monthNode, this.inputsContainer, "last");
      }
    }
  });
  var DateField = declare([_BaseField], {
    templateString: tplDateField,
    validateAsType: "date",
    validateAsGroup: true,
    postCreate: function () {
      this.inherited(arguments);
      if (this.dateformat === "MM/DD/YYYY") {
        domConstruct.place(this.monthNode, this.inputsContainer, "first");
        domConstruct.place(this.yearNode, this.inputsContainer, "last");
      } else if (this.dateformat === "DD/MM/YYYY") {
        domConstruct.place(this.dayNode, this.inputsContainer, "first");
        domConstruct.place(this.yearNode, this.inputsContainer, "last");
      }
    }
  });
  var PhoneField = declare([_BaseField], {
    templateString: tplPhoneField,
    validateAsType: "phone",
    validateAsGroup: true
  });
  var SmsPhoneNumber = declare([_BaseField], {
    templateString: tplSmsPhoneField,
    validateAsType: "smsphone",
    legal: "",
    smsProgramData: "",
    postCreate: function () {
      this.inherited(arguments);
      var legalNode;
      var smsPrefix;
      if (this.smsProgramData !== "") {
        smsPrefix = domConstruct.toDom("<span " + 'data-dojo-attach-point="smsPrefix" ' + "id={prefixTextId} " + "className={stylesheet.inputPrefix} " + 'style="padding-left:16px;padding-right:4px;align-content:center;">' + '<div style="display:flex; align-content:flex-start;align-items:center;gap:10px">' + "<img " + 'src="' + this.smsProgramData[0].imgSrc + '" ' + 'alt="Country Code" width="28" height="28">' + "</img>" + "</span>");
        domConstruct.place(smsPrefix, this.smsInputWrapper, 0);
        domStyle.set(this.smsInputWrapper, "display", "flex");
        domStyle.set(this.smsInputWrapper, "border", "2px solid #c9c9c9");
        domStyle.set(this.smsPhoneInput, "border", "none");
      }
      if (this.required) {
        legalNode = domConstruct.toDom('<div className="mc-sms-phone-group">' + '<div><input type="checkbox" name="mc-SMSPHONE-ack" id="mc-SMSPHONE-ack" value="true"/></div>' + '<div className="small-meta">' + (this.smsProgramData ? this.smsProgramData[0].requiredTemplate : this.legal.required) + "</div>" + "</div>");
      } else {
        legalNode = domConstruct.toDom('<div className="mc-sms-phone-group">' + '<div className="small-meta">' + (this.smsProgramData ? this.smsProgramData[0].optionalTemplate : this.legal.optional) + "</div>" + "</div>");
      }
      domConstruct.place(legalNode, this.smsLegal);
    }
  });
  var UrlField = declare([_BaseField], {
    templateString: tplUrlField,
    validateAsType: "url"
  });
  var RadioCheckboxField = declare([_BaseField], {
    templateString: tplRadioCheckboxField,
    validateAsType: "radiocheckbox",
    postCreate: function () {
      array.forEach(this.choices, lang.hitch(this, function (choice, i) {
        // Create a unique id for each choice for use with label, (e.g., group[3]-3-0 or MMERGE17-0)
        var id = this.merge_id ? this.name + "-" + i : this.name + "-" + this.group_id + "-" + i;
        id = "mc-" + id;
        var el = '<li><input id ="' + id + '" type="' + this.type + '" value="' + choice.value + '" name="' + this.name;
        // If it's a checkbox, make the input name an array with values as keys
        if (this.type === "checkbox") {
          el += "[" + choice.value + "]";
        }
        el += '" /><label for="' + id + '">' + choice.label + "</label></li>";
        domConstruct.place(el, this.choicesContainer, "last");
      }));
      this.inherited(arguments);
    }
  });
  var GdprCheckboxField = declare([_BaseField], {
    templateString: tplGdprCheckboxField,
    validateAsType: "radiocheckbox"
  });
  var GdprContentContainer = declare([_WidgetBase, _TemplatedMixin], {
    templateString: tplGdprBlock,
    gdprLabel: "",
    gdprDescription: "",
    gdprLegal: "",
    gdprMCLegal: "",
    postCreate: function () {
      this.inherited(arguments);
      domConstruct.place(this.gdprMCLegal, this.gdprMcLegalContainer);
      domConstruct.place(this.gdprLegal, this.gdprLegalInput);
    }
  });
  var SelectField = declare([_BaseField], {
    templateString: tplSelectField,
    validateAsType: "select",
    postCreate: function () {
      var emptyOptionNodes = []; // Keep track of empty nodes. We'll set one of them to selected, or create one if none exist.
      array.forEach(this.choices, lang.hitch(this, function (choice) {
        var option = domConstruct.toDom('<option value="' + choice.value + '">' + choice.label + "</option>");
        if (this._empty(choice.label)) {
          emptyOptionNodes.push(option);
        }
        domConstruct.place(option, this.choicesContainer, "last");
      }));
      // If there's no empty option, create one. Otherwise add 'selected' attribute to first empty option node.
      if (emptyOptionNodes.length > 0) {
        domAttr.set(emptyOptionNodes[0], "selected", "selected");
      } else {
        domConstruct.place('<option value="" selected="selected"></option>', this.choicesContainer, "first");
      }
      this.inherited(arguments);
    }
  });
  return declare("SignupForm", [_WidgetBase, _TemplatedMixin, Evented], {
    templateString: tplForm,
    honeypotFieldName: "",
    isPreview: false,
    canSubmit: true,
    // User-configurable attributes
    config: {},
    translations: {},
    subscribeUrl: "#",
    fields: [],
    buttonLabel: "Subscribe",
    description: "",
    // HTML from CK editor
    footer: "",
    // HTML from CK editor
    continueLabel: "Continue",
    // For SMS step functionality
    confirmationDuration: 3.0,
    constructor: function () {
      this.formIsValid = false;
      this.fieldNodes = [];
    },
    postMixInProperties: function () {
      // Pull values from the config
      this.fields = this.config.fields;
      this.footer = this.config.footer;
      this.description = this.config.description;
      this.modalVariation = this.config.modalVariation;
      this.template = this.config.template;
      this.hasGdprEnabled = this.config.hasGdprEnabled;
      this.gdprLabel = this.config.gdprLabel;
      this.gdprDescription = this.config.gdprDescription;
      this.translations = this.config.translations;
      this.confirmationDuration = this.config.confirmationDuration;
      var hasEmailField = this.fields.some(function (field) {
        return field.type === "email";
      });
      if (!hasEmailField) {
        this.hasGdprEnabled = false;
      }
      if (this.hasGdprEnabled) {
        // dom.Construct.toDom for HTML of gdprMCLegal to properly render.
        // surround with <span> to ensure valid HTML fragment.
        this.gdprMCLegal = domConstruct.toDom("<span>" + this.config.gdprMCLegal + "</span>");
        this.gdprLegal = domConstruct.toDom("<span>" + this.config.gdprLegal + "</span>");
      }
      if (this.config.buttonLabel) {
        this.buttonLabel = this.config.buttonLabel;
      }
      if (this.config.continueLabel) {
        this.continueLabel = this.config.continueLabel;
      }

      /*
       * smsField serves two functions:
       * 1. We put it in a different container than the other fields
       *    so that it can be in a separate step.
       * 2. If the field exists, we use that as a toggle for showing/hiding
       *    the relevant elements.
       */
      this.fields.some(lang.hitch(this, function (field) {
        if (field.type === "smsphone") {
          this.config.smsField = field;
          return true;
        }
      }));

      // The format here is important to ensure cross-browser compatibility as of March 2024
      this.tttHref = "sms://" + this.config.smsTransportNumber + "?&body=SIGNUP";
    },
    postCreate: function () {
      // Load GDPR container widget
      if (this.hasGdprEnabled) {
        this.gdprContainer = new GdprContentContainer({
          gdprLabel: this.gdprLabel,
          gdprDescription: this.gdprDescription,
          gdprLegal: this.gdprLegal,
          gdprMCLegal: this.gdprMCLegal
        });

        // Insert widget if modal variation is not the fixed one
        if (this.modalVariation === "modal" && this.template !== 5) {
          this.gdprContainer.placeAt(this.formFieldsContainer, "after");
        }
      }
      this.addFields();
      this.updateElementsForSms();
      this.addHoneypot();
      this.applyStrictContentClasses();
      if (this.footer) {
        this.footer = this.footer.trim();
        if (this.footer !== "" && this.footer !== "<p></p>") {
          html.set(this.footerContainer, this.footer);
        }
      }
      html.set(this.descriptionContainer, this.description);

      // Handle onSubmit event
      on(this.formNode, "submit", lang.hitch(this, "handleFormSubmit"));
      this.config.handleFormSubmit = lang.hitch(this, "handleFormSubmit");
      this.config.resizeFrame = lang.hitch(this, function () {
        this.emit("resizeFrame", {});
      });
      this.updateBadge();
    },
    handleFormSubmit: function (evt) {
      // Prevent page to navigate away
      if (evt) {
        evt.stopPropagation();
        evt.preventDefault();
      }
      if (this.isPreview) {
        var formSuccessNode = this.getOrCreateFormSuccessNode();
        domStyle.set(formSuccessNode, "display", "none");
        var msg = this.config.hasDoubleOptIn ? this.config.doubleOptInSuccessMessage : this.config.successMsg;
        this.setFormSuccessMessage(msg);
        var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
        if (formErrorsNode) {
          domStyle.set(formErrorsNode, "display", "none");
        }

        // Reset the form
        this.formNode.reset();

        // Reset inline field validation
        array.forEach(this.fieldNodes, function (input) {
          input.resetField();
        });

        // Hide the form
        domStyle.set(this.formContentContainer, "display", "none");
        domStyle.set(this.formImageContainer, "display", "none");
        domStyle.set(formSuccessNode, "display", "block");

        // Hide the success message after 3 seconds
        var modalClose = query(".mc-closeModal", this.modalClose)[0];
        var mcModal = query(".mc-modal", this.mcModal)[0];
        var mcModalOverlay = query(".mc-modal-bg", this.modalOverlay)[0];
        var mcBanner = query(".mc-banner", this.mcBanner)[0];
        domStyle.set(modalClose, "pointerEvents", "none");
        this.emit("resizeFrame", {});
        setTimeout(lang.hitch(this, function () {
          domStyle.set(formSuccessNode, "display", "none");
          if (this.config.useMobileBanner === "Y") {
            domStyle.set(mcBanner, "display", "block");
            domStyle.set(mcModal, "visibility", null);
            domStyle.set(mcModalOverlay, "visibility", null);
          }
          domStyle.set(this.formContentContainer, "display", "block");
          domStyle.set(this.formImageContainer, "display", "block");
          domStyle.set(modalClose, "display", "block");
          domStyle.set(mcModal, "display", "block");
          domStyle.set(mcModalOverlay, "display", "block");
          if (this.config.useEmailStep === "Y") {
            domStyle.set(this.emailContentContainer, "display", "block");
            domStyle.set(this.smsContentContainer, "display", "none");
          } else {
            domStyle.set(this.emailContentContainer, "display", "none");
            domStyle.set(this.smsContentContainer, "display", "block");
          }
          domStyle.set(modalClose, "pointerEvents", "auto");
          this.emit("resizeFrame", {});
        }), this.confirmationDuration * 1000);
        return;
      }
      if (!this.canSubmit) {
        return;
      }
      this._validateForm(this.translations);
      if (this.formIsValid) {
        // If we don't have any errors, submit the form.
        // If we need to use captcha, redirect to the list manage captcha endpoint
        if (this.config.captcha) {
          var postUrl = this._getCaptchaForm();
          window.open(postUrl);
          // after opening new window, close modal
          domStyle.set(query(".mc-closeModal", this.modalClose)[0], "display", "none");
          domStyle.set(query(".mc-modal", this.mcModal)[0], "display", "none");
          domStyle.set(query(".mc-modal-bg", this.modalOverlay)[0], "display", "none");
        } else {
          domClass.add(this.submitButton, "button-loading");
          domAttr.set(this.submitButton, "disabled", true);
          domClass.add(this.smsSubmitButton, "button-loading");
          domAttr.set(this.smsSubmitButton, "disabled", true);
          script.get(this._getJsonPostUrl(), {
            jsonp: "c",
            query: domForm.toQuery(this.formNode)
          }).then(lang.hitch(this, function (response) {
            domClass.remove(this.submitButton, "button-loading");
            domAttr.remove(this.submitButton, "disabled");
            domClass.remove(this.smsSubmitButton, "button-loading");
            domAttr.remove(this.smsSubmitButton, "disabled");
            if (response.result === "error") {
              this._handleErrorResponse(response);
            } else {
              this._handleSuccessResponse(response);
              if (response.webEngagementCookieValue) {
                this.setCookie("mcListMember", response.webEngagementCookieValue, 7889238000);
              }
            }
            this.emit("resizeFrame", {});
          }));
        }
        this.setCookieOnSubscribe();
      } else {
        this.emit("resizeFrame", {});
      }
    },
    /**
     * Any popup that will have a baseFontSize style will ahead to a new preset values of font-sizes that
     * cascade off the strictContent classname
     */
    applyStrictContentClasses: function () {
      if (this.isStrictContent()) {
        var cssClasses = this.getStrictContentContainerClasses();
        domClass.add(this.formContentContainer, cssClasses);
      }
    },
    // Checks if the signup form is using strict content which will have preset font-size values
    isStrictContent: function () {
      return Boolean(this.config.styles && this.config.styles.baseFontSize);
    },
    // Return css classes that are applied to containers that display content using the strict content styles
    getStrictContentContainerClasses: function () {
      return this.isStrictContent() ? "strictContent " + this.config.styles.baseFontSize : "";
    },
    /*
     * @param cookie_name {string}
     * @param cookie_value {string}
     * @param expires_at {int}  in milliseconds
     */
    setCookie: function (cookie_name, cookie_value, expires_at) {
      var expires = expires_at || 7889238000;
      var now = new Date();
      var expires_date = new Date(now.getTime() + expires);
      document.cookie = cookie_name + "=" + cookie_value + ";expires=" + expires_date.toUTCString() + ";path=/";
    },
    setCookieOnSubscribe: function () {
      var now = new Date();
      var expires_date = new Date(now.getTime() + 7889238000); // expires 3 months (represented in milliseconds) from now
      document.cookie = "MCPopupSubscribed=yes;expires=" + expires_date.toUTCString() + ";path=/";
    },
    updateBadge: function () {
      //this will add badges if they are needed. It is also called by the privew in the editor to update
      //if the field is showing or not.
      var shouldShow = this.config.version !== "1.0" && !!this.config.useRewards && !!this.config.rewardsUrl;
      var badgesCreated = this.textBadge && this.textBadgefixed;
      if (shouldShow && !badgesCreated) {
        //if the badge is needed and we dont have it add it now
        this.textBadgefixed = new TextBadge({
          rewardsUrl: this.config.rewardsUrl
        }).placeAt(this.fixedBadge, "last");
        this.textBadge = new TextBadge({
          rewardsUrl: this.config.rewardsUrl
        }).placeAt(this.formContentContainer, "after");
      } else if (!shouldShow && badgesCreated) {
        //if the badge is not needed and we do have it remove it now
        this.textBadgefixed.destroyRecursive(false);
        this.textBadge.destroyRecursive(false);
        this.textBadgefixed = null;
        this.textBadge = null;
      }
    },
    updateElementsForSms: function () {
      if (this.config.smsField && this.continueButton) {
        this.continueButton.style.display = "table";
        this.submitButton.style.display = "none";
        this.smsSubmitButton.style.display = "table";
        this.canSubmit = this.config.useEmailStep === "N";

        // Handle "Continue" click for SMS forms
        var self = this;
        on(this.continueButton, "click", function (evt) {
          evt.stopPropagation();
          evt.preventDefault();
          self._validateForm(self.translations, true);
          if (self.formIsValid) {
            self.smsContentContainer.style.display = "block";
            self.emailContentContainer.style.display = "none";
            self.canSubmit = true;
          }
          self.emit("resizeFrame", {});
        });

        // Hide email step if it's disabled
        if (this.config.useEmailStep === "N") {
          domStyle.set(this.emailContentContainer, "display", "none");
          domStyle.set(this.smsContentContainer, "display", "block");
        }
      }
    },
    addFields: function () {
      if (this.fieldNodes.length) {
        array.forEach(this.fieldNodes, function (input) {
          input.destroy();
        });
        this.fieldNodes = [];
        domConstruct.empty(this.formFieldsContainer);
        domConstruct.empty(this.smsFormFieldsContainer);
        if (this.hasGdprEnabled) {
          domConstruct.empty(this.gdprContainer.gdprFieldsContainer);
        }
      }
      array.forEach(this.fields, lang.hitch(this, function (fieldData) {
        if (fieldData.marketing_preference_id && !this.hasGdprEnabled) {
          return;
        }
        var field = this._createField(fieldData);
        if (this.hasGdprEnabled && fieldData.marketing_preference_id) {
          field.placeAt(this.gdprContainer.gdprFieldsContainer);
        } else if (field.type === "smsphone") {
          field.placeAt(this.smsFormFieldsContainer);
          // Add the SMS field legal copy to the TTT step
          html.set(this.tttLegalCopy, field.required ? field.legal.required : field.legal.optional);
          // Hide the SMS skip button if SMS is required
          if (field.required) {
            domStyle.set(this.smsOptOut, "display", "none");
          }
        } else if (this.config.useEmailStep === "Y") {
          field.placeAt(this.formFieldsContainer);
        }
        field.startup();
      }));
    },
    /*
     * Returns the Email Field from this form.
     *
     * There should only be one email field and this method assumes that.
     *
     * @returns {EmailField|null}
     */
    getEmailField: function () {
      var emails = array.filter(this.fieldNodes, function (field) {
        return field.type === "email";
      });
      return emails.length ? emails[0] : null;
    },
    addHoneypot: function () {
      var trap = domConstruct.toDom('<div style="position:absolute;left:-5000px;" aria-hidden="true"><input type="text" name="' + this.honeypotFieldName + '" tabindex="-1" value=""></div>');
      // fixed format requires different absolute offset to prevent scrolling in IE
      if (this.modalVariation === "fixed") {
        trap = domConstruct.toDom('<div style="position:absolute;top:-5000px;width:0" aria-hidden="true"><input type="text" name="' + this.honeypotFieldName + '" tabindex="-1" value=""></div>');
      }
      domConstruct.place(trap, this.formFieldsContainer, "last");
    },
    _validateForm: function (translations, isContinueClick) {
      var formErrors = [];
      array.forEach(this.fieldNodes, lang.hitch(this, function (field) {
        // Allow the SMS field to be empty if the user hasn't gotten to it yet
        // Also, skip validation of non-SMS field if email step is disabled
        if (!(isContinueClick && field.type === "smsphone") && !(this.config.useEmailStep === "N" && field.type !== "smsphone")) {
          var e = field.validateField(translations);
          if (e.length > 0) {
            formErrors.push(e);
          }
        }
      }));
      this.formIsValid = !(formErrors.length > 0);
    },
    _createField: function (fieldData) {
      var field;
      switch (fieldData.type) {
        case "email":
          field = new EmailField(fieldData);
          break;
        case "address":
          field = new AddressField(fieldData);
          break;
        case "birthday":
          field = new BirthdayField(fieldData);
          break;
        case "date":
          field = new DateField(fieldData);
          break;
        case "phone":
          field = fieldData.phoneformat === "US" ? new PhoneField(fieldData) : new TextField(fieldData);
          break;
        case "smsphone":
          field = new SmsPhoneNumber(fieldData);
          break;
        case "number":
          field = new NumberField(fieldData);
          break;
        case "select":
        case "dropdown":
          field = new SelectField(fieldData);
          break;
        case "radio":
        case "checkbox":
          if (fieldData.marketing_preference_id) {
            field = new GdprCheckboxField(fieldData);
          } else {
            field = new RadioCheckboxField(fieldData);
          }
          break;
        case "url":
        case "image":
          field = new UrlField(fieldData);
          break;
        case "text":
        default:
          field = new TextField(fieldData);
      }
      this.fieldNodes.push(field);
      return field;
    },
    /*
     * Return the dom element that will be used to add a success message. Creates the dom element if not available.
     *
     * @return {HTMLElement}
     */
    getOrCreateFormSuccessNode: function () {
      // Make a form success response div if one doesn't already exist
      var formSuccessNode = this.getFormSuccessNode();
      if (!formSuccessNode) {
        var nodeClasses = ("popup-signup-success " + this.getStrictContentContainerClasses()).trim();
        formSuccessNode = domConstruct.place('<div class="' + nodeClasses + '"></div>', this.formResponseMessages);
      }
      return formSuccessNode;
    },
    /*
     * Sets the success message for the form.
     *
     * @param {string} htmlContent
     */
    setFormSuccessMessage: function (htmlContent) {
      var formSuccessNode = this.getOrCreateFormSuccessNode();
      html.set(formSuccessNode, htmlContent);
    },
    /*
     * Return the success message node if it's available.
     *
     * @return {?HTMLElement}
     */
    getFormSuccessNode: function () {
      return query(".popup-signup-success", this.formResponseMessages)[0];
    },
    _handleSuccessResponse: function (response) {
      var formSuccessNode = this.getOrCreateFormSuccessNode();
      var msg = "";
      var type = response.type;
      if (type !== "custom") {
        // Set to the default msg from controller / These styles are located in editor.js as well
        msg = "<span style='font-size: 24px;'>" + "<span style='font-family:arial,helvetica neue,helvetica,sans-serif;'>" + response.msg + "</span></span>";
      } else {
        // Show custom message
        msg = response.msg;
      }
      this.setFormSuccessMessage(msg);
      var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
      if (formErrorsNode) {
        domStyle.set(formErrorsNode, "display", "none");
      }

      // Reset the form
      this.formNode.reset();

      // Reset inline field validation
      array.forEach(this.fieldNodes, function (input) {
        input.resetField();
      });

      // Hide the form
      domStyle.set(this.formContentContainer, "display", "none");
      domStyle.set(this.formImageContainer, "display", "none");
      if (type !== "confirmation") {
        // Hide the success message after 3 seconds
        var modalClose = query(".mc-closeModal", this.modalClose)[0];
        var mcModal = query(".mc-modal", this.mcModal)[0];
        var mcModalOverlay = query(".mc-modal-bg", this.modalOverlay)[0];
        setTimeout(lang.hitch(this, function () {
          domStyle.set(formSuccessNode, "display", "none");
          domStyle.set(modalClose, "display", "none");
          domStyle.set(mcModal, "display", "none");
          domStyle.set(mcModalOverlay, "display", "none");
        }), this.confirmationDuration * 1000);
      }
    },
    _handleErrorResponse: function (response) {
      // Hide form success response div if exists
      var formSuccessNode = this.getFormSuccessNode();
      if (formSuccessNode) {
        domStyle.set(formSuccessNode, "display", "none");
      }

      // Display form error if one exists
      if (response.msg) {
        // Make a form error response div if one doesn't already exist
        var formErrorsNode = query(".flash-errors", this.formResponseMessages)[0];
        if (!formErrorsNode) {
          formErrorsNode = domConstruct.place('<div class="flash-errors"></div>', this.formResponseMessages);
        }
        html.set(formErrorsNode, response.msg);

        // FIXME: Ideally we'd deal with elsewhere so the js doesn't have to
        // make fragile assumptions about the layout
        var computedStyle = domStyle.getComputedStyle(this.formImageContainer);
        if (computedStyle.position === "absolute") {
          domStyle.set(this.formImageContainer, {
            top: domGeom.getMarginBox(formErrorsNode).h + "px"
          });
        }
      }

      // Display any field-specific error messages inline
      if (response.errors) {
        // This is flagged on the php end, so should not be triggered if flag is off.
        if (this.hasGdprEnabled && response.type === "gdpr_error") {
          // If there's a gdpr error, attach the error to that field
          var gdprErrorNode = "<div class='invalid-error'>" + response.errors["msg"] + "</div>";
          domConstruct.place(gdprErrorNode, this.gdprContainer.gdprFormResponseMessages, "only");
        } else {
          array.forEach(this.fieldNodes, function (input) {
            if (response.errors.hasOwnProperty(input.merge_id)) {
              input.setFieldAsInvalid(response.errors[input.merge_id]);
            } else {
              input.setFieldAsValid();
            }
          });
        }
      }
    },
    _getJsonPostUrl: function () {
      var url = this.subscribeUrl;
      url = url.replace("/form-post?u=", "/form-post-json?u=");
      return url;
    },
    // morph the post endpoint to the captcha, get all params as objects
    // then parse them back into a url and return that string.
    _getCaptchaForm: function () {
      var url = this.subscribeUrl.replace("/form-post?u=", "/post?u=");
      var urlQuery = url.substring(url.indexOf("?") + 1, url.length);
      var base = url.split("?")[0];
      var urlQueryObject = ioQuery.queryToObject(urlQuery);
      var formObject = domForm.toObject(this.formNode);
      var newUrlQueryObj = Object.assign(urlQueryObject, formObject);
      var queryStr = ioQuery.objectToQuery(newUrlQueryObj);
      return base + "?" + queryStr;
    },
    toHTML: function () {
      return this.domNode.outerHTML;
    }
  });
});